import { render, staticRenderFns } from "./confirmInsureModal.vue?vue&type=template&id=81949824&scoped=true"
import script from "./confirmInsureModal.vue?vue&type=script&lang=js"
export * from "./confirmInsureModal.vue?vue&type=script&lang=js"
import style0 from "./confirmInsureModal.vue?vue&type=style&index=0&id=81949824&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81949824",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81949824')) {
      api.createRecord('81949824', component.options)
    } else {
      api.reload('81949824', component.options)
    }
    module.hot.accept("./confirmInsureModal.vue?vue&type=template&id=81949824&scoped=true", function () {
      api.rerender('81949824', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/groupOrderManage/batchInsurance/components/confirmInsureModal.vue"
export default component.exports